"use client";
import { Button } from "@/components/button/button.component";
import { PlusIcon } from "@/components/icons/plus.icon";
import { Text } from "@/components/text/text.component";
import { Loader } from "@/components/loader/loader.component";
import cn from "classnames";

export const QuantityStepperAdd = ({
  id,
  handleAction,
  pending,
}: QuantityStepperAddProps) => {
  return (
    <form action={handleAction} className="inline-flex" aria-busy={pending}>
      <Button
        type="submit"
        disabled={pending}
        aria-disabled={pending}
        className={cn(
          `border-secondary flex cursor-pointer items-center justify-center rounded-full border p-1`,
          {
            "pointer-events-none": pending,
          },
        )}>
        <Text
          className="text-secondary user-select-none flex items-center justify-center pl-2"
          variant="subtitle2">
          ADD
        </Text>
        <input type="hidden" name="action" value="increase" />
        <input type="hidden" name="itemId" value={id} />
        <div
          className="flex h-8 w-8 items-center justify-center"
          aria-label="Increase quantity">
          {pending ? (
            <Loader loading size="sm" />
          ) : (
            <PlusIcon width={20} height={20} />
          )}
        </div>
      </Button>
    </form>
  );
};

export type QuantityStepperAddProps = {
  id: string;
  handleAction: (formData: FormData) => Promise<void>;
  pending: boolean;
};
